export const votingEn = {
  inputButtonHint: 'Add voting',
  popupTitle: 'Add voting',
  menuAdd: 'Add voting',
  popupCaption: 'Question',
  popupOptions: 'Answer options',
  questionPlaceholder: 'Enter a question',
  answerPlaceholder: 'Answer #',
  createVoting: 'Create voting',
  addAnswer: 'Add variant',
  addAnswerHint: (num: number) => `You can add ${num} more options`,
  addAnswerHintMax: `Added maximum number of fields`,
  addFewVar: 'You can select several options',
  errorCountAnswers: 'There must be at least 2 answer options',
  confirmBack: 'You have unsaved changes. Close without saving?',
  doVoting: 'Vote',
  stat: (val: number) => `Voted: ${val}`
}

export const votingRu: typeof votingEn = {
  inputButtonHint: 'Добавить голосование',
  popupTitle: 'Добавить голосование',
  menuAdd: 'Добавить голосование',
  popupCaption: 'Вопрос',
  popupOptions: 'Варианты ответов',
  questionPlaceholder: 'Введите вопрос',
  answerPlaceholder: 'Ответ №',
  createVoting: 'Создать опрос',
  addAnswer: 'Добавить вариант',
  addAnswerHint: (num: number) => `Вы можете добавить ещё ${num} вариантов`,
  addAnswerHintMax: `Добавлено максимальное количество полей`,
  addFewVar: 'Можно выбрать несколько вариантов',
  errorCountAnswers: 'Вариантов ответа должно быть минимум 2',
  confirmBack: 'У вас есть несохранённые изменения. Закрыть без сохранения?',
  doVoting: 'Проголосовать',
  stat: (val: number) => `Проголосовало: ${val}`
}
